import { createFileRoute } from '@tanstack/react-router';

import { ReportCataloguePage } from '@/features/reports/reports-pages';

export const Route = createFileRoute('/_app/org/$orgId/reports/')({
  component: CompanyReportsRoute,
});

function CompanyReportsRoute() {
  const { orgId } = Route.useParams();
  return <ReportCataloguePage scope={{ kind: 'org', id: orgId }} />;
}
